module.exports = __webpack_public_path__ + "static/media/FourthInstallImg.ef33b949.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FourthInstallImg.jpg
// module id = 1145
// module chunks = 0